import { render, staticRenderFns } from "./detail-receipt-record.vue?vue&type=template&id=0f00af94"
import script from "./detail-receipt-record.vue?vue&type=script&lang=js"
export * from "./detail-receipt-record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports